import { deletePayPurpose, fetchPayPurpose } from "../../../redux/paypurposeSlice";
import { updateDonation } from "../../../redux/donationSlice";
import { logger } from "../../../utils/logger";

/**
 * Handle row double click to navigate to donations
 */
export const handleRowDoubleclick = (params, onMenuSelect) => {
  const transactionId = params.data.transactionId;
  if (onMenuSelect) {
    onMenuSelect("donations", { transactionId });
  }
};

/**
 * Handle edit click - find matching donation and open modal
 */
export const handleEditClick = (params, allDonations, setEditData, setOpen) => {
  const transactionId = params.data.transactionId;
  const matchingDonation = allDonations.find(
    (donation) => donation.transactionId === transactionId
  );

  const combinedData = { ...matchingDonation, ...params.data };
  combinedData._id = matchingDonation?._id || params.data._id;

  // For paypurpose-specific fields, prefer the one that has a value
  const paypurposeFields = ['tributeName', 'sharma', 'poojaDate', 'tamilMonths', 'nachathiram', 'thithi', 'utsavam', 'complete'];
  paypurposeFields.forEach(field => {
    let value = params.data[field] || matchingDonation?.[field] || "";
    if (field === 'complete') {
      // Ensure complete is a Boolean
      value = value === "" ? false : Boolean(value);
    }
    combinedData[field] = value;
  });

  setEditData(combinedData);
  setOpen(true);
};

/**
 * Handle delete click - open confirmation dialog
 */
export const handleDeleteClick = (params, setSelectedPayPurposeId, setConfirmOpen) => {
  setSelectedPayPurposeId(params.data._id);
  setConfirmOpen(true);
};

/**
 * Handle confirmed delete action
 */
export const handleConfirmDelete = async (
  selectedPayPurposeId,
  dispatch,
  setFeedback,
  setConfirmOpen,
  setSelectedPayPurposeId
) => {
  try {
    await dispatch(deletePayPurpose(selectedPayPurposeId));
    setFeedback({
      open: true,
      message: "PayPurpose deleted successfully",
      severity: "success",
    });
    dispatch(fetchPayPurpose());
  } catch (err) {
    logger.error("Delete failed in paypurpose table:", err);
    setFeedback({
      open: true,
      message: "Failed to delete PayPurpose",
      severity: "error",
    });
  } finally {
    setConfirmOpen(false);
    setSelectedPayPurposeId(null);
  }
};

/**
 * Handle form submission
 */
export const handleSubmit = async (
  formData,
  dispatch,
  setFeedback,
  setOpen,
  setEditData
) => {
  try {
    if (!formData._id) {
      setFeedback({
        open: true,
        message: "Donation ID is missing. Cannot update.",
        severity: "error",
      });
      return;
    }

    await dispatch(updateDonation(formData));
    setFeedback({
      open: true,
      message: "Paypurpose updated successfully",
      severity: "success",
    });
    dispatch(fetchPayPurpose());

    setOpen(false);
    setEditData(null);
  } catch (error) {
    logger.error("Update failed in paypurpose:", error);
    alert("Failed to update donation");
  }
};

/**
 * Handle modal submit by triggering form ref
 */
export const handleModalSubmit = (formRef) => {
  if (formRef.current) {
    formRef.current.submitForm();
  }
};

/**
 * Handle feedback close
 */
export const handleCloseFeedback = (feedback, setFeedback) => {
  setFeedback({ ...feedback, open: false });
};
